import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * `tailwind-merge` con los tamaños de texto del sistema de diseño.
 *
 * Sin esto no sabe que `text-cuerpo` o `text-etiqueta` son **tamaños**
 * (`--text-*` en `estilos/tokens.css`): los toma por colores y, al resolver
 * el conflicto, se queda con el último. Un botón primario pequeño perdía así
 * su `text-white` y quedaba con el texto casi negro sobre el azul de la marca,
 * ilegible. La lista es la de los `--text-*` del `@theme`; un tamaño nuevo allí
 * se añade aquí.
 */
const unir = extendTailwindMerge({
  extend: {
    theme: {
      text: ['pantalla', 'seccion', 'cuerpo', 'etiqueta', 'mono'],
    },
  },
})

/**
 * Une clases y resuelve conflictos de Tailwind dejando ganar la última.
 * Permite que un componente base acepte `className` sin que el consumidor
 * tenga que pelear con la especificidad.
 */
export function cx(...entradas: ClassValue[]): string {
  return unir(clsx(entradas))
}
